import React, { useState, useEffect, Fragment, useRef } from 'react';
import { AUTH_CONFIG } from '../../../../Auth/auth0-variables';
import axios from 'axios';
import {
    Persona, PersonaSize, PrimaryButton, DefaultButton, SearchBox, DetailsList, NormalPeoplePicker, CheckboxVisibility, Checkbox, Spinner, SpinnerSize
} from '@fluentui/react';
import _ from "lodash"
import { shallowEqual, useSelector } from 'react-redux';

function ChatDetails(props) {
    const [items, setItems] = React.useState([]);
    const columns = [
        {
            key: 'more',
            name: '',
            fieldName: 'userId',
            onRender: (item) => {
                return buildRow(item)
            }
        },
    ];

    const buildRow = (item) => {
        return <div className="displayflex flex1 aligncenter" style={{ justifyContent: 'space-between' }}>
            <div className="displayflex flex1" >
                <Persona
                    key={item.userId}
                    imageUrl={item.profileImage ? process.env.REACT_APP_CDN_URL + item.profileImage : null}
                    imageInitials={item.imageInitials}
                    text={item.text}
                    initialsColor={item.initialsColor}
                    size={PersonaSize.size24}
                />
            </div>
        </div>
    }
    const { employees } = useSelector(state => ({
        employees: state.appState.product.facility.employees
    }));

    useEffect(() => {
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetChatDetails?chatid=" + props.chatId)
            .then((response) => {
                
                var items = [];
                var em = employees.filter(item => response.data.includes(item.userId));
                em.forEach((element, index) => {
                    debugger;
                    const item = {
                        role: element.role,
                        checked: false,
                        userId: element.userId,
                        roleId: element.roleId ? element.roleId.toString() : "",
                        key: element.userId.toString(),
                        imageInitials: element.firstName.substring(0, 1) + element.lastName.substring(0, 1),
                        initialsColor: element.avatarColor,
                        text: element.firstName + ' ' + element.lastName,
                        profileImage: element.profileImage ? element.profileImage : null,
                        type: 'employee'
                    };
                    items.push(item);
                });

                setItems(items)
            });
    }, []);

    return (
        <div className={`chat-list ${props.bot ? 'px20' : ''}` }>

            <div className="displayflex flexcolumn width100 border-bottom" style={{ padding: '15px 20px 10px 0' }} >
                
                <h5 className="head-xs" style={{ fontSize: 13 }} >{ items.length} Team Members</h5>
               
            </div>
            <div className="custom-scrollbar height100 employee-picker" style={{ height: 'calc(100% - 400px)', padding: '0', }}>
                <DetailsList
                    selectionPreservedOnEmptyClick={false}
                    items={items}
                    checkboxVisibility={CheckboxVisibility.hidden}
                    columns={columns}
                    isHeaderVisible={false}
                />
            </div>
            
        </div>
    );

}

export default ChatDetails;

